import DashboardLayout from "@/pages/Dashboard/Layout/DasboardLayout";
//Staffs
import StaffListPage from "@/pages/Staffs/ListPage/index.vue";
//Student
import StudentListPage from "@/pages/Students/ListPage/index.vue";
import ClassDetailPage from "@/pages/Classes/DetailPage";
// Router Active
import {
  academic,
  actionLogs,
  assignStudent,
  attendanceReport,
  classes,
  communication,
  counselor,
  dashboard,
  extendedExportation,
  family,
  gradeScale,
  graduated,
  graduation,
  individualAssessmentReport,
  myProfile,
  notification,
  overallAssessmentReport,
  program,
  progressReport,
  role,
  schedule,
  schoolParameter,
  scoreReport,
  staff,
  student,
  subject,
  survey,
  surveyReport,
  taskManagement,
  term,
  zoomMeeting
} from "./routePermission";

// Dashboard pages
const Dashboard = () => import("@/pages/Dashboard/Dashboard.vue");

//Error Page
const Forbidden = () => import("@/pages/ErrorPage/403.vue");

//Authentication Page
const Authentication = () => import("@/pages/Authentication");

const FamilyPage = () => import("@/pages/Family/AccountDetail.vue");

const CounselorInformation = () => import("@/pages/CounselorInformation");

const AcademicPlan = () => import("@/pages/AcademicPlan");

const AssignedStudents = () => import("@/pages/AssignedStudents");

const Notifications = () => import("@/pages/Notification");

const MyProfile = () => import("@/pages/MyProfile/index.vue");

const StaffAddPage = () => import("@/pages/Staffs/AddPage.vue");
const StaffDetailPage = () => import("@/pages/Staffs/EditPage.vue");

const StudentAddPage = () => import("@/pages/Students/AddPage.vue");
const StudentDetailPage = () => import("@/pages/Students/AccountDetail");
const StudentTranscriptPage = () => import("@/pages/Students/Transcript");

//Terms
const TermListPage = () => import("@/pages/Terms/ListPage/index.vue");
const TermDetailPage = () => import("@/pages/Terms/EditPage.vue");

//Class
const ClassListPage = () => import("@/pages/Classes/ListPage");
const ClassAddPage = () => import("@/pages/Classes/AddPage.vue");

// Programs
const ProgramListPage = () => import("@/pages/Programs/ListPage/index.vue");
const ProgramAddPage = () => import("@/pages/Programs/AddPage.vue");
const ProgramDetailPage = () => import("@/pages/Programs/EditPage.vue");

//Grade Scale
const GradeScaleListPage = () => import("@/pages/GradeScale/ListPage");
const GradeScaleAddPage = () => import("@/pages/GradeScale/AddPage");
const GradeScaleDetailPage = () => import("@/pages/GradeScale/DetailPage");

//Schedule
const SchedulePage = () => import("@/pages/Schedule");
const AttendancePage = () => import("@/pages/Schedule/Attendance");
//Communication
const Communication = () => import("@/pages/Communication");

// Subjects
const SubjectListPage = () => import("@/pages/Subjects/ListPage/index.vue");
const SubjectAddPage = () => import("@/pages/Subjects/AddPage.vue");
const SubjectDetailPage = () => import("@/pages/Subjects/EditPage.vue");

//Room meeting
const ZoomMeetingListPage = () => import("@/pages/ZoomMeeting/ListPage");
const ZoomMeetingAddPage = () => import("@/pages/ZoomMeeting/AddZoom");
const ZoomMeetingDetailPage = () => import("@/pages/ZoomMeeting/EditZoom");
const ZoomMeetingReportPage = () =>
  import("@/pages/ZoomMeeting/Report/ReportFromZoom");
const ZoomMeetingReportCalendarPage = () =>
  import("@/pages/ZoomMeeting/Report/ReportCalendar");

// Chat room
const ChatRoomPage = () => import("@/pages/ChatRoom");
// Graduation
const GraduationCategoryListPage = () =>
  import("@/pages/GraduationCategories/ListPage/index.vue");
const GraduationCategoryDetailPage = () =>
  import("@/pages/GraduationCategories/EditPage.vue");
const GraduationStudents = () => import("@/pages/GraduationStudents");

//Survey
const SurveyListPage = () => import("@/pages/Survey/ListPage/index.vue");
const SurveyAddPage = () => import("@/pages/Survey/AddPage.vue");
const SurveyEditPage = () => import("@/pages/Survey/EditPage.vue");
const SurveyClonePage = () => import("@/pages/Survey/CloneSurvey.vue");
// Report
const IndividualAssessment = () => import("@/pages/IndividualAssessment");
const CommunicationLog = () => import("@/pages/CommunicationLog");
const OverallAssessment = () => import("@/pages/OverallAssessment");
const ExtendedExportation = () =>
  import("@/pages/ExtendedExportation/index.vue");
const ScoreReport = () => import("@/pages/Report/Score");
const AttendanceReport = () => import("@/pages/Report/Attendance");
const ProgressReport = () => import("@/pages/ProgressReport");
const ProgressReportDetail = () =>
  import("@/pages/ProgressReport/ProgressReports/[id]/index.vue");
const SurveyReport = () => import("@/pages/SurveyReport");

// Settings
const SchoolParameter = () => import("@/pages/SchoolParameter/index.vue");
const ActionLogs = () => import("@/pages/ActionLogs/index.vue");
const RoleListPage = () => import("@/pages/Roles/ListPage/index.vue");
const RoleAddPage = () => import("@/pages/Roles/AddPage.vue");
const RoleDetailPage = () => import("@/pages/Roles/DetailPage.vue");

//Task Management
const TaskManagement = () => import("@/pages/TaskManagement/index.vue");
const AddMainTask = () =>
  import("@/pages/TaskManagement/AddPage/AddMainPage.vue");
const AddIndividualTask = () =>
  import("@/pages/TaskManagement/AddPage/AddIndividualPage.vue");
const EditMainTask = () =>
  import("@/pages/TaskManagement/EditPage/EditMainPage.vue");
const EditIndividualTask = () =>
  import("@/pages/TaskManagement/EditPage/EditIndividualPage.vue");
const SubtaskDetail = () =>
  import("@/pages/TaskManagement/EditPage/SubtaskDetail.vue");

export const staff_router_names = {
  listPage: "Manage Staff",
  addPage: "Add New Staff",
  detailPage: "Staff Detail"
};
export const term_router_names = {
  listPage: "Manage Term",
  detailPage: "Term Detail"
};

export const graduation_category_router_names = {
  listPage: "Manage Graduation Category",
  editPage: "Graduation Category Detail"
};

export const program_router_names = {
  listPage: "Manage Program",
  addPage: "Add New Program",
  editPage: "Program Detail"
};

export const subject_router_names = {
  listPage: "Manage Subject",
  addPage: "Add New Subject",
  editPage: "Subject Detail"
};

export const student_router_names = {
  listPage: "Manage Student",
  addPage: "Add New Student",
  detailPage: "Account Student",
  transcriptPage: "Transcript Student"
};

export const class_router_names = {
  listPage: "Manage Class",
  addPage: "Add Class",
  detailPage: "Class Detail"
};

export const grade_scale_router_names = {
  listPage: "Manage Grade Scale",
  addPage: "Add new grade scale",
  detailPage: "Grade scale detail"
};

export const schedule_names = {
  listPage: "Manage Schedule",
  attendance: "Attendance"
};

export const communication_names = {
  detailPage: "Communication"
};

export const counselor_information_names = {
  listPage: "Manage Counselor Information"
};

export const academic_plan_names = {
  listPage: "Manage Academic Plan"
};

export const score_report_names = {
  listPage: "Report: Score & GPA"
};

export const attendance_report_names = {
  listPage: "Report: Attendance"
};

export const assigned_students_names = {
  listPage: "Manage Assigned Students"
};

export const role_router_names = {
  listPage: "Manage Role",
  addPage: "Add Role",
  detailPage: "Role Detail"
};

export const notification_names = {
  listPage: "Notifications"
};
export const chat_room_names = {
  listPage: "Chat room"
};

export const zoom_meeting_names = {
  listPage: "Manage Zoom Meeting",
  addPage: "Add zoom",
  detailPage: "Zoom detail",
  reportPage: "Zoom report",
  reportCalendar: "Zoom report calendar"
};

export const extend_exportation = {
  listPage: "ExtendedExportation"
};

export const survey_router_names = {
  listPage: "Manage Survey",
  addPage: "Add New Survey",
  detailPage: "Survey Detail",
  clonePage: "Clone Survey"
};

export const survey_report = {
  listPage: "SurveyPage"
};

export const task_management = {
  listPage: "Task management",
  addMainTask: "Add main task",
  addIndividualTask: "Add Individual task",
  editMainTask: "Edit main task",
  editIndividualTask: "Edit individual task",
  subtaskDetail: "Subtask detail"
};

export const verifications_router_name = "Verifications";
export const dashboard_router_name = "Dashboard";
export const forbidden_router_name = "Forbidden";
export const school_parameter_router_name = "School Parameter";
export const individual_assessment_name = "Individual Assessment";

export const family_router_names = {
  accountDetail: "Account Family"
};

const authPage = {
  path: "/verifications",
  component: Authentication,
  name: verifications_router_name
};

export const staffPages = {
  path: "/staffs",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: staff_router_names.listPage,
      components: { default: StaffListPage },
      meta: { requiresAuth: true, activeRoute: staff.staffList }
    },
    {
      path: "add",
      name: staff_router_names.addPage,
      components: { default: StaffAddPage },
      meta: { requiresAuth: true, activeRoute: staff.staffAdd }
    },
    {
      path: ":id/detail",
      name: staff_router_names.detailPage,
      components: { default: StaffDetailPage },
      meta: { requiresAuth: true, activeRoute: staff.staffDetail }
    }
  ]
};

export const termPages = {
  path: "/terms",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: term_router_names.listPage,
      components: { default: TermListPage },
      meta: { requiresAuth: true, activeRoute: term.termList }
    },
    {
      path: ":id/detail",
      name: term_router_names.detailPage,
      components: { default: TermDetailPage },
      meta: { requiresAuth: true, activeRoute: term.termDetail }
    }
  ]
};

export const graduationCategoryPages = {
  path: "/graduationcategories",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: graduation_category_router_names.listPage,
      components: { default: GraduationCategoryListPage },
      meta: { requiresAuth: true, activeRoute: graduation.list }
    },
    {
      path: ":id/detail",
      name: graduation_category_router_names.editPage,
      components: { default: GraduationCategoryDetailPage },
      meta: { requiresAuth: true, activeRoute: graduation.detail }
    }
  ]
};

export const programPages = {
  path: "/programs",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: program_router_names.listPage,
      components: { default: ProgramListPage },
      meta: { requiresAuth: true, activeRoute: program.list }
    },
    {
      path: "add",
      name: program_router_names.addPage,
      components: { default: ProgramAddPage },
      meta: { requiresAuth: true, activeRoute: program.add }
    },
    {
      path: ":id/detail",
      name: program_router_names.editPage,
      components: { default: ProgramDetailPage },
      meta: { requiresAuth: true, activeRoute: program.detail }
    }
  ]
};

export const subjectPages = {
  path: "/subjects",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: subject_router_names.listPage,
      components: { default: SubjectListPage },
      meta: { requiresAuth: true, activeRoute: subject.list }
    },
    {
      path: "add",
      name: subject_router_names.addPage,
      components: { default: SubjectAddPage },
      meta: { requiresAuth: true, activeRoute: subject.add }
    },
    {
      path: ":id/detail",
      name: subject_router_names.editPage,
      components: { default: SubjectDetailPage },
      meta: { requiresAuth: true, activeRoute: subject.detail }
    }
  ]
};

export const studentPages = {
  path: "/students",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: student_router_names.listPage,
      components: { default: StudentListPage },
      meta: { requiresAuth: true, activeRoute: student.list }
    },
    {
      path: "add",
      name: student_router_names.addPage,
      components: { default: StudentAddPage },
      meta: { requiresAuth: true, activeRoute: student.add }
    },
    {
      path: ":id/detail",
      name: student_router_names.detailPage,
      components: { default: StudentDetailPage },
      meta: { requiresAuth: true, activeRoute: student.detail }
    },
    {
      path: ":id/transcript",
      name: student_router_names.transcriptPage,
      components: { default: StudentTranscriptPage },
      meta: { requiresAuth: true, activeRoute: student.transcript }
    }
  ]
};

export const classPages = {
  path: "/classes",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: class_router_names.listPage,
      components: { default: ClassListPage },
      meta: { requiresAuth: true, activeRoute: classes.list }
    },
    {
      path: "add",
      name: class_router_names.addPage,
      components: { default: ClassAddPage },
      meta: { requiresAuth: true, activeRoute: classes.add }
    },
    {
      path: ":id/detail",
      name: class_router_names.detailPage,
      components: { default: ClassDetailPage },
      meta: { requiresAuth: true, activeRoute: classes.detail }
    }
  ]
};

export const gradeScalePages = {
  path: "/grade-scale",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: grade_scale_router_names.listPage,
      components: { default: GradeScaleListPage },
      meta: { requiresAuth: true, activeRoute: gradeScale.list }
    },
    {
      path: "add",
      name: grade_scale_router_names.addPage,
      components: { default: GradeScaleAddPage },
      meta: { requiresAuth: true, activeRoute: gradeScale.add }
    },
    {
      path: ":id/detail",
      name: grade_scale_router_names.detailPage,
      components: { default: GradeScaleDetailPage },
      meta: { requiresAuth: true, activeRoute: gradeScale.detail }
    }
  ]
};

export const schedulePages = {
  path: "/schedule",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: schedule_names.listPage,
      components: { default: SchedulePage },
      meta: { requiresAuth: true, activeRoute: schedule.list }
    },
    {
      path: ":id/attendance",
      name: schedule_names.attendance,
      components: { default: AttendancePage },
      meta: { requiresAuth: true, activeRoute: schedule.attendance }
    }
  ]
};

export const communicationPages = {
  path: "/communication",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: communication_names.detailPage,
      components: { default: Communication },
      meta: { requiresAuth: true, activeRoute: communication.detail }
    }
  ]
};

export const chatRoomPages = {
  path: "/chat-room",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: chat_room_names.listPage,
      components: { default: ChatRoomPage },
      meta: { requiresAuth: true, activeRoute: () => true }
    }
  ]
};

export const individualAssessment = {
  path: "/individual-assessment",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: individual_assessment_name,
      components: { default: IndividualAssessment },
      meta: {
        requiresAuth: true,
        activeRoute: individualAssessmentReport.detail
      }
    }
  ]
};
export const communicationLog = {
  path: "/communication-log",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Communication Log",
      components: { default: CommunicationLog },
      meta: { requiresAuth: true, activeRoute: () => true }
    }
  ]
};
export const progressReportPages = {
  path: "/progress-report",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Progress Report",
      components: { default: ProgressReport },
      meta: { requiresAuth: true, activeRoute: progressReport.detail }
    },
    {
      path: ":id/detail",
      name: "Progress detail",
      components: { default: ProgressReportDetail },
      meta: { requiresAuth: true, activeRoute: progressReport.detailProgress }
    }
  ]
};

export const surveyReportPages = {
  path: "/survey-report",
  component: DashboardLayout,
  children: [
    {
      path: ":id",
      name: survey_report.listPage,
      components: { default: SurveyReport },
      meta: { requiresAuth: true, activeRoute: surveyReport.detail }
    }
  ]
};

export const overallAssessment = {
  path: "/overall-assessment",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Overall Assessment",
      components: { default: OverallAssessment },
      meta: { requiresAuth: true, activeRoute: overallAssessmentReport.detail }
    }
  ]
};

export const counselorInformationPages = {
  path: "/counselor-information",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: counselor_information_names.listPage,
      components: { default: CounselorInformation },
      meta: { requiresAuth: true, activeRoute: counselor.list }
    }
  ]
};

export const academicPlanPages = {
  path: "/academic-plan",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: academic_plan_names.listPage,
      components: { default: AcademicPlan },
      meta: { requiresAuth: true, activeRoute: academic.list }
    }
  ]
};

export const scoreReportPages = {
  path: "/score-report",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: score_report_names.listPage,
      components: { default: ScoreReport },
      meta: { requiresAuth: true, activeRoute: scoreReport.list }
    }
  ]
};

export const attendanceReportPages = {
  path: "/attendance-report",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: attendance_report_names.listPage,
      components: { default: AttendanceReport },
      meta: { requiresAuth: true, activeRoute: attendanceReport.list }
    }
  ]
};

export const assignedStudentsPages = {
  path: "/assigned-students",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: assigned_students_names.listPage,
      components: { default: AssignedStudents },
      meta: { requiresAuth: true, activeRoute: assignStudent.list }
    }
  ]
};

export const rolePages = {
  path: "/roles",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: role_router_names.listPage,
      components: { default: RoleListPage },
      meta: { requiresAuth: true, activeRoute: role.list }
    },
    {
      path: "add",
      name: role_router_names.addPage,
      components: { default: RoleAddPage },
      meta: { requiresAuth: true, activeRoute: role.add }
    },
    {
      path: ":id/detail",
      name: role_router_names.editPage,
      components: { default: RoleDetailPage },
      meta: { requiresAuth: true, activeRoute: role.detail }
    }
  ]
};

export const familyPages = {
  path: "/families",
  component: DashboardLayout,
  children: [
    {
      path: "my-profile",
      name: family_router_names.accountDetail,
      components: { default: FamilyPage },
      meta: { requiresAuth: true, activeRoute: family.accDetail }
    }
  ]
};
export const notificationPages = {
  path: "/notifications",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: notification_names.listPage,
      components: { default: Notifications },
      meta: { requiresAuth: true, activeRoute: notification.list }
    }
  ]
};

export const actionLogsPage = {
  path: "/action-logs",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Action Logs",
      components: { default: ActionLogs },
      meta: { requiresAuth: true, activeRoute: actionLogs.list }
    }
  ]
};

export const graduationStudentsPages = {
  path: "/graduation-students",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Graduation Students",
      components: { default: GraduationStudents },
      meta: { requiresAuth: true, activeRoute: graduated.list }
    }
  ]
};

export const schoolParameterPages = {
  path: "/school-parameter",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: school_parameter_router_name,
      components: { default: SchoolParameter },
      meta: { requiresAuth: true, activeRoute: schoolParameter.list }
    }
  ]
};

export const myProfilePage = {
  path: "/my-profile",
  component: DashboardLayout,
  children: [
    {
      path: ":id",
      name: "My profile",
      components: { default: MyProfile },
      meta: { requiresAuth: true, activeRoute: myProfile.detail }
    }
  ]
};
export const dashboardPage = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "dashboard",
      name: dashboard_router_name,
      components: { default: Dashboard },
      meta: { requiresAuth: true, activeRoute: dashboard.checkAll }
    }
  ]
};
export const roomMeetingPages = {
  path: "/zoom-meeting",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: zoom_meeting_names.listPage,
      components: { default: ZoomMeetingListPage },
      meta: { requiresAuth: true, activeRoute: zoomMeeting.list }
    },
    {
      path: "add",
      name: zoom_meeting_names.addPage,
      components: { default: ZoomMeetingAddPage },
      meta: { requiresAuth: true, activeRoute: zoomMeeting.add }
    },
    {
      path: ":id/detail",
      name: zoom_meeting_names.detailPage,
      components: { default: ZoomMeetingDetailPage },
      meta: { requiresAuth: true, activeRoute: zoomMeeting.detail }
    },
    {
      path: ":id/report",
      name: zoom_meeting_names.reportPage,
      components: { default: ZoomMeetingReportPage },
      meta: { requiresAuth: true, activeRoute: () => zoomMeeting.report }
    },
    {
      path: ":id/report-calendar",
      name: zoom_meeting_names.reportCalendar,
      components: { default: ZoomMeetingReportCalendarPage },
      meta: { requiresAuth: true, activeRoute: () => schedule.list }
    }
  ]
};

export const extendedExportationPage = {
  path: "/extended-exportation",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: extend_exportation.listPage,
      components: { default: ExtendedExportation },
      meta: { requiresAuth: true, activeRoute: extendedExportation.export }
    }
  ]
};
export const surveyPages = {
  path: "/survey",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: survey_router_names.listPage,
      components: { default: SurveyListPage },
      meta: { requiresAuth: true, activeRoute: survey.list }
    },
    {
      path: "add",
      name: survey_router_names.addPage,
      components: { default: SurveyAddPage },
      meta: { requiresAuth: true, activeRoute: survey.add }
    },
    {
      path: ":id/detail",
      name: survey_router_names.editPage,
      components: { default: SurveyEditPage },
      meta: { requiresAuth: true, activeRoute: survey.detail }
    },
    {
      path: ":id/clone",
      name: survey_router_names.clonePage,
      components: { default: SurveyClonePage },
      meta: { requiresAuth: true, activeRoute: survey.clone }
    }
  ]
};

export const taskManagementPage = {
  path: "/task-management",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: task_management.listPage,
      components: { default: TaskManagement },
      meta: { requiresAuth: true, activeRoute: taskManagement.detail }
    },
    {
      path: "/add-main-task",
      name: task_management.addMainTask,
      components: { default: AddMainTask },
      meta: { requiresAuth: true, activeRoute: taskManagement.add }
    },
    {
      path: "/add-individual-task",
      name: task_management.addIndividualTask,
      components: { default: AddIndividualTask },
      meta: { requiresAuth: true, activeRoute: taskManagement.add }
    },
    {
      path: "/edit-main-task/:id",
      name: task_management.editMainTask,
      components: { default: EditMainTask },
      meta: { requiresAuth: true, activeRoute: () => true }
    },
    {
      path: "/edit-individual-task/:id",
      name: task_management.editIndividualTask,
      components: { default: EditIndividualTask },
      meta: { requiresAuth: true, activeRoute: () => true }
    },
    {
      path: "/sub-task/:id",
      name: task_management.subtaskDetail,
      components: { default: SubtaskDetail },
      meta: { requiresAuth: true, activeRoute: () => true }
    }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home"
  },
  staffPages,
  studentPages,
  authPage,
  termPages,
  classPages,
  graduationCategoryPages,
  programPages,
  gradeScalePages,
  schedulePages,
  subjectPages,
  communicationPages,
  individualAssessment,
  communicationLog,
  overallAssessment,
  counselorInformationPages,
  academicPlanPages,
  scoreReportPages,
  attendanceReportPages,
  assignedStudentsPages,
  rolePages,
  familyPages,
  notificationPages,
  actionLogsPage,
  graduationStudentsPages,
  schoolParameterPages,
  myProfilePage,
  dashboardPage,
  extendedExportationPage,
  roomMeetingPages,
  chatRoomPages,
  progressReportPages,
  surveyPages,
  surveyReportPages,
  taskManagementPage,
  {
    path: "/403",
    name: forbidden_router_name,
    components: { default: Forbidden },
    meta: { requiresAuth: true, activeRoute: dashboard.checkAll }
  }
];

export default routes;
